// 负责 Mock 支付 Provider 纯函数，与订单状态机和 Mock checkout 页面关联。
import type { Order } from "../orders";
import type { MockPaymentOutcome, PaymentEvent } from "../orders";
import type { PaymentSession } from "./provider";

export type CreateMockPaymentEventInput = {
  orderId: string;
  outcome: MockPaymentOutcome;
  createId: () => string;
  now: () => string;
};

// 为订单创建 Mock 支付会话，后续可替换为服务端 Provider 调用。
export const createMockPaymentSession = (order: Order): PaymentSession => {
  if (order.paymentStatus !== "pending") {
    throw new Error(
      `Order ${order.id} must be pending before creating a payment session.`
    );
  }

  return {
    provider: "mock",
    orderId: order.id,
    redirectView: "mock-checkout"
  };
};

// 创建 Mock 支付事件，用来模拟第三方 webhook 的核心输入。
export const createMockPaymentEvent = ({
  orderId,
  outcome,
  createId,
  now
}: CreateMockPaymentEventInput): PaymentEvent => {
  return {
    id: createId(),
    orderId,
    outcome,
    createdAt: now()
  };
};
